import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissDelay: { type: Number, default: 4000 } // 4 seconds in milliseconds
  }

  connect() {
    if (this.autoDismissValue) {
      this.scheduleAutoDismiss()
    }

    // Add click event listener for manual dismiss
    this.addDismissListeners()
  }

  scheduleAutoDismiss() {
    setTimeout(() => {
      this.dismiss()
    }, this.dismissDelayValue)
  }

  addDismissListeners() {
    // Find all dismiss buttons within this flash message
    const dismissButtons = this.element.querySelectorAll('[data-dismiss="alert"], .btn-close, a[aria-label="Close"]')

    dismissButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        this.dismiss()
      })
    })
  }

  dismiss() {
    // Add fade out animation
    this.element.style.transition = 'opacity 0.3s ease-out'
    this.element.style.opacity = '0'

    // Remove the element after animation
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove()
      }
    }, 300)
  }

  // Method to manually dismiss from other controllers
  dismissManually() {
    this.dismiss()
  }
}
